import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Header from "../../stories/components/Header.js";
import LogoTableRow from "../../stories/components/LogoTableRow";
import LogoTableHead from "../../stories/components/LogoTableHead";

import {
    LogoStafPrimaerBokmaalNegativPdf,
    LogoStafPrimaerBokmaalNegativPng,
    LogoStafPrimaerBokmaalNegativSvg,
    LogoStafPrimaerBokmaalPositivPdf,
    LogoStafPrimaerBokmaalPositivPng,
    LogoStafPrimaerBokmaalPositivSvg,
    LogoStafPrimaerBokmaalNegativPdfTjenestelofte,
    LogoStafPrimaerBokmaalNegativPngTjenestelofte,
    LogoStafPrimaerBokmaalNegativSvgTjenestelofte,
    LogoStafPrimaerBokmaalPositivPdfTjenestelofte,
    LogoStafPrimaerBokmaalPositivPngTjenestelofte,
    LogoStafPrimaerBokmaalPositivSvgTjenestelofte,
    LogoStafPrimaerBokmaalEngelskNegativPdf,
    LogoStafPrimaerBokmaalEngelskNegativPng,
    LogoStafPrimaerBokmaalEngelskNegativSvg,
    LogoStafPrimaerBokmaalEngelskPositivPdf,
    LogoStafPrimaerBokmaalEngelskPositivPng,
    LogoStafPrimaerBokmaalEngelskPositivSvg,
    LogoStafPrimaerNynorskNegativPdf,
    LogoStafPrimaerNynorskNegativPng,
    LogoStafPrimaerNynorskNegativSvg,
    LogoStafPrimaerNynorskPositivPdf,
    LogoStafPrimaerNynorskPositivPng,
    LogoStafPrimaerNynorskPositivSvg,
    LogoStafPrimaerNynorskNegativPdfTjenestelofte,
    LogoStafPrimaerNynorskNegativPngTjenestelofte,
    LogoStafPrimaerNynorskNegativSvgTjenestelofte,
    LogoStafPrimaerNynorskPositivPdfTjenestelofte,
    LogoStafPrimaerNynorskPositivPngTjenestelofte,
    LogoStafPrimaerNynorskPositivSvgTjenestelofte,
    LogoStafPrimaerNynorskEngelskNegativPdf,
    LogoStafPrimaerNynorskEngelskNegativPng,
    LogoStafPrimaerNynorskEngelskNegativSvg,
    LogoStafPrimaerNynorskEngelskPositivPdf,
    LogoStafPrimaerNynorskEngelskPositivPng,
    LogoStafPrimaerNynorskEngelskPositivSvg,
    LogoStafPrimaerLulesamiskNegativPdf,
    LogoStafPrimaerLulesamiskNegativPng,
    LogoStafPrimaerLulesamiskNegativSvg,
    LogoStafPrimaerLulesamiskPositivPdf,
    LogoStafPrimaerLulesamiskPositivPng,
    LogoStafPrimaerLulesamiskPositivSvg,
    LogoStafPrimaerNordsamiskNegativPdf,
    LogoStafPrimaerNordsamiskNegativPng,
    LogoStafPrimaerNordsamiskNegativSvg,
    LogoStafPrimaerNordsamiskPositivPdf,
    LogoStafPrimaerNordsamiskPositivPng,
    LogoStafPrimaerNordsamiskPositivSvg,
    LogoStafPrimaerSørsamiskNegativPdf,
    LogoStafPrimaerSørsamiskNegativPng,
    LogoStafPrimaerSørsamiskNegativSvg,
    LogoStafPrimaerSørsamiskPositivPdf,
    LogoStafPrimaerSørsamiskPositivPng,
    LogoStafPrimaerSørsamiskPositivSvg,

    LogoStafSekundaerBokmaalNegativPdf,
    LogoStafSekundaerBokmaalNegativPng,
    LogoStafSekundaerBokmaalNegativSvg,
    LogoStafSekundaerBokmaalPositivPdf,
    LogoStafSekundaerBokmaalPositivPng,
    LogoStafSekundaerBokmaalPositivSvg,
    LogoStafSekundaerBokmaalNegativPdfTjenestelofte,
    LogoStafSekundaerBokmaalNegativPngTjenestelofte,
    LogoStafSekundaerBokmaalNegativSvgTjenestelofte,
    LogoStafSekundaerBokmaalPositivPdfTjenestelofte,
    LogoStafSekundaerBokmaalPositivPngTjenestelofte,
    LogoStafSekundaerBokmaalPositivSvgTjenestelofte,
    LogoStafSekundaerBokmaalEngelskNegativPdf,
    LogoStafSekundaerBokmaalEngelskNegativPng,
    LogoStafSekundaerBokmaalEngelskNegativSvg,
    LogoStafSekundaerBokmaalEngelskPositivPdf,
    LogoStafSekundaerBokmaalEngelskPositivPng,
    LogoStafSekundaerBokmaalEngelskPositivSvg,
    LogoStafSekundaerNynorskNegativPdf,
    LogoStafSekundaerNynorskNegativPng,
    LogoStafSekundaerNynorskNegativSvg,
    LogoStafSekundaerNynorskPositivPdf,
    LogoStafSekundaerNynorskPositivPng,
    LogoStafSekundaerNynorskPositivSvg,
    LogoStafSekundaerNynorskNegativPdfTjenestelofte,
    LogoStafSekundaerNynorskNegativPngTjenestelofte,
    LogoStafSekundaerNynorskNegativSvgTjenestelofte,
    LogoStafSekundaerNynorskPositivPdfTjenestelofte,
    LogoStafSekundaerNynorskPositivPngTjenestelofte,
    LogoStafSekundaerNynorskPositivSvgTjenestelofte,
    LogoStafSekundaerNynorskEngelskNegativPdf,
    LogoStafSekundaerNynorskEngelskNegativPng,
    LogoStafSekundaerNynorskEngelskNegativSvg,
    LogoStafSekundaerNynorskEngelskPositivPdf,
    LogoStafSekundaerNynorskEngelskPositivPng,
    LogoStafSekundaerNynorskEngelskPositivSvg,
    LogoStafSekundaerLulesamiskNegativPdf,
    LogoStafSekundaerLulesamiskNegativPng,
    LogoStafSekundaerLulesamiskNegativSvg,
    LogoStafSekundaerLulesamiskPositivPdf,
    LogoStafSekundaerLulesamiskPositivPng,
    LogoStafSekundaerLulesamiskPositivSvg,
    LogoStafSekundaerNordsamiskNegativPdf,
    LogoStafSekundaerNordsamiskNegativPng,
    LogoStafSekundaerNordsamiskNegativSvg,
    LogoStafSekundaerNordsamiskPositivPdf,
    LogoStafSekundaerNordsamiskPositivPng,
    LogoStafSekundaerNordsamiskPositivSvg,
    LogoStafSekundaerSørsamiskNegativPdf,
    LogoStafSekundaerSørsamiskNegativPng,
    LogoStafSekundaerSørsamiskNegativSvg,
    LogoStafSekundaerSørsamiskPositivPdf,
    LogoStafSekundaerSørsamiskPositivPng,
    LogoStafSekundaerSørsamiskPositivSvg,

    LogoStafSentrertBokmaalNegativPdf,
    LogoStafSentrertBokmaalNegativPng,
    LogoStafSentrertBokmaalNegativSvg,
    LogoStafSentrertBokmaalPositivPdf,
    LogoStafSentrertBokmaalPositivPng,
    LogoStafSentrertBokmaalPositivSvg,
    LogoStafSentrertBokmaalNegativPdfTjenestelofte,
    LogoStafSentrertBokmaalNegativPngTjenestelofte,
    LogoStafSentrertBokmaalNegativSvgTjenestelofte,
    LogoStafSentrertBokmaalPositivPdfTjenestelofte,
    LogoStafSentrertBokmaalPositivPngTjenestelofte,
    LogoStafSentrertBokmaalPositivSvgTjenestelofte,
    LogoStafSentrertBokmaalEngelskNegativPdf,
    LogoStafSentrertBokmaalEngelskNegativPng,
    LogoStafSentrertBokmaalEngelskNegativSvg,
    LogoStafSentrertBokmaalEngelskPositivPdf,
    LogoStafSentrertBokmaalEngelskPositivPng,
    LogoStafSentrertBokmaalEngelskPositivSvg,
    LogoStafSentrertNynorskNegativPdf,
    LogoStafSentrertNynorskNegativPng,
    LogoStafSentrertNynorskNegativSvg,
    LogoStafSentrertNynorskPositivPdf,
    LogoStafSentrertNynorskPositivPng,
    LogoStafSentrertNynorskPositivSvg,
    LogoStafSentrertNynorskNegativPdfTjenestelofte,
    LogoStafSentrertNynorskNegativPngTjenestelofte,
    LogoStafSentrertNynorskNegativSvgTjenestelofte,
    LogoStafSentrertNynorskPositivPdfTjenestelofte,
    LogoStafSentrertNynorskPositivPngTjenestelofte,
    LogoStafSentrertNynorskPositivSvgTjenestelofte,
    LogoStafSentrertNynorskEngelskNegativPdf,
    LogoStafSentrertNynorskEngelskNegativPng,
    LogoStafSentrertNynorskEngelskNegativSvg,
    LogoStafSentrertNynorskEngelskPositivPdf,
    LogoStafSentrertNynorskEngelskPositivPng,
    LogoStafSentrertNynorskEngelskPositivSvg,
    LogoStafSentrertLulesamiskNegativPdf,
    LogoStafSentrertLulesamiskNegativPng,
    LogoStafSentrertLulesamiskNegativSvg,
    LogoStafSentrertLulesamiskPositivPdf,
    LogoStafSentrertLulesamiskPositivPng,
    LogoStafSentrertLulesamiskPositivSvg,
    LogoStafSentrertNordsamiskNegativPdf,
    LogoStafSentrertNordsamiskNegativPng,
    LogoStafSentrertNordsamiskNegativSvg,
    LogoStafSentrertNordsamiskPositivPdf,
    LogoStafSentrertNordsamiskPositivPng,
    LogoStafSentrertNordsamiskPositivSvg,
    LogoStafSentrertSørsamiskNegativPdf,
    LogoStafSentrertSørsamiskNegativPng,
    LogoStafSentrertSørsamiskNegativSvg,
    LogoStafSentrertSørsamiskPositivPdf,
    LogoStafSentrertSørsamiskPositivPng,
    LogoStafSentrertSørsamiskPositivSvg
} from "../../assets/logo/STAF/exportStaf.js";


export default function StafPage() {
    return (
      <Container className="mb-6">
        <article>
          <Header
            title="Logofiler for Statsforvalternes Fellestjenester"
            lead="Alle logoer for Statsforvalternes Fellestjenester i ulike variasjoner og filformater"
            breadcrumbText="Tilbake til logo"
            breadcrumbUrl="/logo"
          />
          <main>
            <Row>
              <Col md={{ span: 8, offset: 2 }}>
                <p>Tekst om logovarianter og filformater...</p>
              </Col>
            </Row>
            <Row className="my-6">
              <Col>
                <h4>Primærlogo</h4>
                <Table responsive size="lg" className="table-simple">
                  <LogoTableHead />
                  <tbody>
                  <LogoTableRow
                      logoUrl={LogoStafPrimaerBokmaalPositivSvg}
                      title="Primærlogo: Statsforvalternes Fjellestjenester, bokmål"
                      text="Bokmål"
                      blackSvg={LogoStafPrimaerBokmaalPositivSvg}
                      blackPng={LogoStafPrimaerBokmaalPositivPng}
                      blackPdf={LogoStafPrimaerBokmaalPositivPdf}
                      whiteSvg={LogoStafPrimaerBokmaalNegativSvg}
                      whitePng={LogoStafPrimaerBokmaalNegativPng}
                      whitePdf={LogoStafPrimaerBokmaalNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafPrimaerBokmaalPositivSvgTjenestelofte}
                      title="Primærlogo: Statsforvalternes Fjellestjenester, bokmål + tjenesteløfte"
                      text="Bokmål med tjenesteløfte"
                      blackSvg={LogoStafPrimaerBokmaalPositivSvgTjenestelofte}
                      blackPng={LogoStafPrimaerBokmaalPositivPngTjenestelofte}
                      blackPdf={LogoStafPrimaerBokmaalPositivPdfTjenestelofte}
                      whiteSvg={LogoStafPrimaerBokmaalNegativSvgTjenestelofte}
                      whitePng={LogoStafPrimaerBokmaalNegativPngTjenestelofte}
                      whitePdf={LogoStafPrimaerBokmaalNegativPdfTjenestelofte}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafPrimaerBokmaalEngelskPositivSvg}
                      title="Primærlogo: Statsforvalternes Fellestjenester, bokmål + engelsk"
                      text="Bokmål + engelsk"
                      blackSvg={LogoStafPrimaerBokmaalEngelskPositivSvg}
                      blackPng={LogoStafPrimaerBokmaalEngelskPositivPng}
                      blackPdf={LogoStafPrimaerBokmaalEngelskPositivPdf}
                      whiteSvg={LogoStafPrimaerBokmaalEngelskNegativSvg}
                      whitePng={LogoStafPrimaerBokmaalEngelskNegativPng}
                      whitePdf={LogoStafPrimaerBokmaalEngelskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafPrimaerNynorskPositivSvg}
                      title="Primærlogo: Statsforvalternes Fellestjenester, nynorsk"
                      text="Nynorsk"
                      blackSvg={LogoStafPrimaerNynorskPositivSvg}
                      blackPng={LogoStafPrimaerNynorskPositivPng}
                      blackPdf={LogoStafPrimaerNynorskPositivPdf}
                      whiteSvg={LogoStafPrimaerNynorskNegativSvg}
                      whitePng={LogoStafPrimaerNynorskNegativPng}
                      whitePdf={LogoStafPrimaerNynorskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafPrimaerBokmaalPositivSvgTjenestelofte}
                      title="Primærlogo: Statsforvalternes Fjellestjenester, nynorsk + tjenesteløfte"
                      text="Nynorsk med tjenesteløfte"
                      blackSvg={LogoStafPrimaerNynorskPositivSvgTjenestelofte}
                      blackPng={LogoStafPrimaerNynorskPositivPngTjenestelofte}
                      blackPdf={LogoStafPrimaerNynorskPositivPdfTjenestelofte}
                      whiteSvg={LogoStafPrimaerNynorskNegativSvgTjenestelofte}
                      whitePng={LogoStafPrimaerNynorskNegativPngTjenestelofte}
                      whitePdf={LogoStafPrimaerNynorskNegativPdfTjenestelofte}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafPrimaerNynorskEngelskPositivSvg}
                      title="Primærlogo: Statsforvalternes Fellestjenester, nynorsk + engelsk"
                      text="Nynorsk + engelsk"
                      blackSvg={LogoStafPrimaerNynorskEngelskPositivSvg}
                      blackPng={LogoStafPrimaerNynorskEngelskPositivPng}
                      blackPdf={LogoStafPrimaerNynorskEngelskPositivPdf}
                      whiteSvg={LogoStafPrimaerNynorskEngelskNegativSvg}
                      whitePng={LogoStafPrimaerNynorskEngelskNegativPng}
                      whitePdf={LogoStafPrimaerNynorskEngelskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafPrimaerLulesamiskPositivSvg}
                      title="Primærlogo: Statsforvalternes Fjellestjenester, lulesamisk"
                      text="Lulesamisk"
                      blackSvg={LogoStafPrimaerLulesamiskPositivSvg}
                      blackPng={LogoStafPrimaerLulesamiskPositivPng}
                      blackPdf={LogoStafPrimaerLulesamiskPositivPdf}
                      whiteSvg={LogoStafPrimaerLulesamiskNegativSvg}
                      whitePng={LogoStafPrimaerLulesamiskNegativPng}
                      whitePdf={LogoStafPrimaerLulesamiskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafPrimaerNordsamiskPositivSvg}
                      title="Primærlogo: Statsforvalternes Fjellestjenester, nordsamisk"
                      text="Nordsamisk"
                      blackSvg={LogoStafPrimaerNordsamiskPositivSvg}
                      blackPng={LogoStafPrimaerNordsamiskPositivPng}
                      blackPdf={LogoStafPrimaerNordsamiskPositivPdf}
                      whiteSvg={LogoStafPrimaerNordsamiskNegativSvg}
                      whitePng={LogoStafPrimaerNordsamiskNegativPng}
                      whitePdf={LogoStafPrimaerNordsamiskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafPrimaerSørsamiskPositivSvg}
                      title="Primærlogo: Statsforvalternes Fjellestjenester, sørsamisk"
                      text="Sørsamisk"
                      blackSvg={LogoStafPrimaerSørsamiskPositivSvg}
                      blackPng={LogoStafPrimaerSørsamiskPositivPng}
                      blackPdf={LogoStafPrimaerSørsamiskPositivPdf}
                      whiteSvg={LogoStafPrimaerSørsamiskNegativSvg}
                      whitePng={LogoStafPrimaerSørsamiskNegativPng}
                      whitePdf={LogoStafPrimaerSørsamiskNegativPdf}
                    />
                  </tbody>
                </Table>
              </Col>
            </Row>
            <Row className="my-6">
              <Col>
                <h4>Sekundærlogo</h4>
                <Table responsive size="lg" className="table-simple">
                  <LogoTableHead />
                  <tbody>
                  <LogoTableRow
                      logoUrl={LogoStafSekundaerBokmaalPositivSvg}
                      title="Sekundærlogo: Statsforvalternes Fjellestjenester, bokmål"
                      text="Bokmål"
                      blackSvg={LogoStafSekundaerBokmaalPositivSvg}
                      blackPng={LogoStafSekundaerBokmaalPositivPng}
                      blackPdf={LogoStafSekundaerBokmaalPositivPdf}
                      whiteSvg={LogoStafSekundaerBokmaalNegativSvg}
                      whitePng={LogoStafSekundaerBokmaalNegativPng}
                      whitePdf={LogoStafSekundaerBokmaalNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSekundaerBokmaalPositivSvgTjenestelofte}
                      title="Sekundær: Statsforvalternes Fjellestjenester, bokmål + tjenesteløfte"
                      text="Bokmål med tjenesteløfte"
                      blackSvg={LogoStafSekundaerBokmaalPositivSvgTjenestelofte}
                      blackPng={LogoStafSekundaerBokmaalPositivPngTjenestelofte}
                      blackPdf={LogoStafSekundaerBokmaalPositivPdfTjenestelofte}
                      whiteSvg={LogoStafSekundaerBokmaalNegativSvgTjenestelofte}
                      whitePng={LogoStafSekundaerBokmaalNegativPngTjenestelofte}
                      whitePdf={LogoStafSekundaerBokmaalNegativPdfTjenestelofte}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSekundaerBokmaalEngelskPositivSvg}
                      title="Sekundær: Statsforvalternes Fellestjenester, bokmål + engelsk"
                      text="Bokmål + engelsk"
                      blackSvg={LogoStafSekundaerBokmaalEngelskPositivSvg}
                      blackPng={LogoStafSekundaerBokmaalEngelskPositivPng}
                      blackPdf={LogoStafSekundaerBokmaalEngelskPositivPdf}
                      whiteSvg={LogoStafSekundaerBokmaalEngelskNegativSvg}
                      whitePng={LogoStafSekundaerBokmaalEngelskNegativPng}
                      whitePdf={LogoStafSekundaerBokmaalEngelskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSekundaerNynorskPositivSvg}
                      title="Sekundærlogo: Statsforvalternes Fellestjenester, nynorsk"
                      text="Nynorsk"
                      blackSvg={LogoStafSekundaerNynorskPositivSvg}
                      blackPng={LogoStafSekundaerNynorskPositivPng}
                      blackPdf={LogoStafSekundaerNynorskPositivPdf}
                      whiteSvg={LogoStafSekundaerNynorskNegativSvg}
                      whitePng={LogoStafSekundaerNynorskNegativPng}
                      whitePdf={LogoStafSekundaerNynorskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSekundaerNynorskPositivSvgTjenestelofte}
                      title="Sekundær: Statsforvalternes Fjellestjenester, nynorsk + tjenesteløfte"
                      text="Nynorsk med tjenesteløfte"
                      blackSvg={LogoStafSekundaerNynorskPositivSvgTjenestelofte}
                      blackPng={LogoStafSekundaerNynorskPositivPngTjenestelofte}
                      blackPdf={LogoStafSekundaerNynorskPositivPdfTjenestelofte}
                      whiteSvg={LogoStafSekundaerNynorskNegativSvgTjenestelofte}
                      whitePng={LogoStafSekundaerNynorskNegativPngTjenestelofte}
                      whitePdf={LogoStafSekundaerNynorskNegativPdfTjenestelofte}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSekundaerNynorskEngelskPositivSvg}
                      title="Sekundærlogo: Statsforvalternes Fellestjenester, nynorsk + engelsk"
                      text="Nynorsk + engelsk"
                      blackSvg={LogoStafSekundaerNynorskEngelskPositivSvg}
                      blackPng={LogoStafSekundaerNynorskEngelskPositivPng}
                      blackPdf={LogoStafSekundaerNynorskEngelskPositivPdf}
                      whiteSvg={LogoStafSekundaerNynorskEngelskNegativSvg}
                      whitePng={LogoStafSekundaerNynorskEngelskNegativPng}
                      whitePdf={LogoStafSekundaerNynorskEngelskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSekundaerLulesamiskPositivSvg}
                      title="Sekundærlogo: Statsforvalternes Fjellestjenester, lulesamisk"
                      text="Lulesamisk"
                      blackSvg={LogoStafSekundaerLulesamiskPositivSvg}
                      blackPng={LogoStafSekundaerLulesamiskPositivPng}
                      blackPdf={LogoStafSekundaerLulesamiskPositivPdf}
                      whiteSvg={LogoStafSekundaerLulesamiskNegativSvg}
                      whitePng={LogoStafSekundaerLulesamiskNegativPng}
                      whitePdf={LogoStafSekundaerLulesamiskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSekundaerNordsamiskPositivSvg}
                      title="Sekundærlogo: Statsforvalternes Fjellestjenester, nordsamisk"
                      text="Nordsamisk"
                      blackSvg={LogoStafSekundaerNordsamiskPositivSvg}
                      blackPng={LogoStafSekundaerNordsamiskPositivPng}
                      blackPdf={LogoStafSekundaerNordsamiskPositivPdf}
                      whiteSvg={LogoStafSekundaerNordsamiskNegativSvg}
                      whitePng={LogoStafSekundaerNordsamiskNegativPng}
                      whitePdf={LogoStafSekundaerNordsamiskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSekundaerSørsamiskPositivSvg}
                      title="Sekundærlogo: Statsforvalternes Fjellestjenester, sørsamisk"
                      text="Sørsamisk"
                      blackSvg={LogoStafSekundaerSørsamiskPositivSvg}
                      blackPng={LogoStafSekundaerSørsamiskPositivPng}
                      blackPdf={LogoStafSekundaerSørsamiskPositivPdf}
                      whiteSvg={LogoStafSekundaerSørsamiskNegativSvg}
                      whitePng={LogoStafSekundaerSørsamiskNegativPng}
                      whitePdf={LogoStafSekundaerSørsamiskNegativPdf}
                    />
                  </tbody>
                </Table>
              </Col>
            </Row>

            <Row className="my-6">
              <Col>
                <h4>Sentrert</h4>
                <Table responsive size="lg" className="table-simple">
                  <LogoTableHead />
                  <tbody>
                  <LogoTableRow
                      logoUrl={LogoStafSentrertBokmaalPositivSvg}
                      title="Sentrert logo: Statsforvalternes Fjellestjenester, bokmål"
                      text="Bokmål"
                      blackSvg={LogoStafSentrertBokmaalPositivSvg}
                      blackPng={LogoStafSentrertBokmaalPositivPng}
                      blackPdf={LogoStafSentrertBokmaalPositivPdf}
                      whiteSvg={LogoStafSentrertBokmaalNegativSvg}
                      whitePng={LogoStafSentrertBokmaalNegativPng}
                      whitePdf={LogoStafSentrertBokmaalNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSentrertBokmaalPositivSvgTjenestelofte}
                      title="Sentrert logo: Statsforvalternes Fjellestjenester, bokmål + tjenesteløfte"
                      text="Bokmål med tjenesteløfte"
                      blackSvg={LogoStafSentrertBokmaalPositivSvgTjenestelofte}
                      blackPng={LogoStafSentrertBokmaalPositivPngTjenestelofte}
                      blackPdf={LogoStafSentrertBokmaalPositivPdfTjenestelofte}
                      whiteSvg={LogoStafSentrertBokmaalNegativSvgTjenestelofte}
                      whitePng={LogoStafSentrertBokmaalNegativPngTjenestelofte}
                      whitePdf={LogoStafSentrertBokmaalNegativPdfTjenestelofte}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSentrertBokmaalEngelskPositivSvg}
                      title="Sentrert logo: Statsforvalternes Fellestjenester, bokmål + engelsk"
                      text="Bokmål + engelsk"
                      blackSvg={LogoStafSentrertBokmaalEngelskPositivSvg}
                      blackPng={LogoStafSentrertBokmaalEngelskPositivPng}
                      blackPdf={LogoStafSentrertBokmaalEngelskPositivPdf}
                      whiteSvg={LogoStafSentrertBokmaalEngelskNegativSvg}
                      whitePng={LogoStafSentrertBokmaalEngelskNegativPng}
                      whitePdf={LogoStafSentrertBokmaalEngelskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSentrertNynorskPositivSvg}
                      title="Sentrert logo: Statsforvalternes Fellestjenester, nynorsk"
                      text="Nynorsk"
                      blackSvg={LogoStafSentrertNynorskPositivSvg}
                      blackPng={LogoStafSentrertNynorskPositivPng}
                      blackPdf={LogoStafSentrertNynorskPositivPdf}
                      whiteSvg={LogoStafSentrertNynorskNegativSvg}
                      whitePng={LogoStafSentrertNynorskNegativPng}
                      whitePdf={LogoStafSentrertNynorskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSentrertBokmaalPositivSvgTjenestelofte}
                      title="Sentrert logo: Statsforvalternes Fjellestjenester, nynorsk + tjenesteløfte"
                      text="Nynorsk med tjenesteløfte"
                      blackSvg={LogoStafSentrertNynorskPositivSvgTjenestelofte}
                      blackPng={LogoStafSentrertNynorskPositivPngTjenestelofte}
                      blackPdf={LogoStafSentrertNynorskPositivPdfTjenestelofte}
                      whiteSvg={LogoStafSentrertNynorskNegativSvgTjenestelofte}
                      whitePng={LogoStafSentrertNynorskNegativPngTjenestelofte}
                      whitePdf={LogoStafSentrertNynorskNegativPdfTjenestelofte}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSentrertNynorskEngelskPositivSvg}
                      title="Sentrert logo: Statsforvalternes Fellestjenester, nynorsk + engelsk"
                      text="Nynorsk + engelsk"
                      blackSvg={LogoStafSentrertNynorskEngelskPositivSvg}
                      blackPng={LogoStafSentrertNynorskEngelskPositivPng}
                      blackPdf={LogoStafSentrertNynorskEngelskPositivPdf}
                      whiteSvg={LogoStafSentrertNynorskEngelskNegativSvg}
                      whitePng={LogoStafSentrertNynorskEngelskNegativPng}
                      whitePdf={LogoStafSentrertNynorskEngelskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSentrertLulesamiskPositivSvg}
                      title="Sentrert logo: Statsforvalternes Fjellestjenester, lulesamisk"
                      text="Lulesamisk"
                      blackSvg={LogoStafSentrertLulesamiskPositivSvg}
                      blackPng={LogoStafSentrertLulesamiskPositivPng}
                      blackPdf={LogoStafSentrertLulesamiskPositivPdf}
                      whiteSvg={LogoStafSentrertLulesamiskNegativSvg}
                      whitePng={LogoStafSentrertLulesamiskNegativPng}
                      whitePdf={LogoStafSentrertLulesamiskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSentrertNordsamiskPositivSvg}
                      title="Sentrert logo: Statsforvalternes Fjellestjenester, nordsamisk"
                      text="Nordsamisk"
                      blackSvg={LogoStafSentrertNordsamiskPositivSvg}
                      blackPng={LogoStafSentrertNordsamiskPositivPng}
                      blackPdf={LogoStafSentrertNordsamiskPositivPdf}
                      whiteSvg={LogoStafSentrertNordsamiskNegativSvg}
                      whitePng={LogoStafSentrertNordsamiskNegativPng}
                      whitePdf={LogoStafSentrertNordsamiskNegativPdf}
                    />
                    <LogoTableRow
                      logoUrl={LogoStafSentrertSørsamiskPositivSvg}
                      title="Sentrert logo: Statsforvalternes Fjellestjenester, sørsamisk"
                      text="Sørsamisk"
                      blackSvg={LogoStafSentrertSørsamiskPositivSvg}
                      blackPng={LogoStafSentrertSørsamiskPositivPng}
                      blackPdf={LogoStafSentrertSørsamiskPositivPdf}
                      whiteSvg={LogoStafSentrertSørsamiskNegativSvg}
                      whitePng={LogoStafSentrertSørsamiskNegativPng}
                      whitePdf={LogoStafSentrertSørsamiskNegativPdf}
                    />
                  </tbody>
                </Table>
              </Col>
            </Row>
            
          </main>
        </article>
      </Container>
    );
  }
  